<template>
    <div class="m-ar-distance">
        {{ Math.round(stepsCount*0.6) }} / {{ distance }} m
    </div>
</template>

<script>
export default {
    name: 'MArDistance',
    props: {
        distance: {
            type: Number,
            default: null
        },

        stepsCount: {
            type: Number,
            default: null
        },

    },
}
</script>

<style lang="scss" src="./theme.scss" />
